import { render, staticRenderFns } from "./AddOnboardingDocumentsComponent.vue?vue&type=template&id=ad81bf5e&"
import script from "./AddOnboardingDocumentsComponent.vue?vue&type=script&lang=js&"
export * from "./AddOnboardingDocumentsComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddOnboardingDocumentsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports